var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#E5F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.441 11.4583C15.235 11.7666 15.125 12.1292 15.125 12.5C15.125 12.9973 15.3225 13.4742 15.6742 13.8258C16.0258 14.1775 16.5027 14.375 17 14.375C17.3708 14.375 17.7334 14.265 18.0417 14.059C18.35 13.853 18.5904 13.5601 18.7323 13.2175C18.8742 12.8749 18.9113 12.4979 18.839 12.1342C18.7666 11.7705 18.588 11.4364 18.3258 11.1742C18.0636 10.912 17.7295 10.7334 17.3658 10.661C17.0021 10.5887 16.6251 10.6258 16.2825 10.7677C15.9399 10.9096 15.647 11.15 15.441 11.4583ZM21.9205 17.0455C22.1315 16.8345 22.25 16.5484 22.25 16.25C22.25 15.9516 22.1315 15.6655 21.9205 15.4545C21.7095 15.2435 21.4234 15.125 21.125 15.125H12.875C12.5766 15.125 12.2905 15.2435 12.0795 15.4545C11.8685 15.6655 11.75 15.9516 11.75 16.25C11.75 16.5484 11.8685 16.8345 12.0795 17.0455C12.2905 17.2565 12.5766 17.375 12.875 17.375H15.875V17.4228L13.4262 21.2713C13.2759 21.5227 13.2296 21.8228 13.2971 22.1079C13.3647 22.3929 13.5407 22.6404 13.7879 22.7977C14.035 22.9549 14.3337 23.0096 14.6206 22.95C14.9074 22.8905 15.1596 22.7214 15.3237 22.4788L17 19.8453L18.6753 22.4788C18.7769 22.6385 18.9173 22.7701 19.0833 22.8612C19.2493 22.9523 19.4356 23.0001 19.625 23C19.839 23.0007 20.0487 22.9395 20.2288 22.8238C20.4803 22.6635 20.6579 22.41 20.7226 22.1189C20.7873 21.8278 20.7338 21.5229 20.5737 21.2713L18.125 17.4228V17.375H21.125C21.4234 17.375 21.7095 17.2565 21.9205 17.0455Z",
    fill: "#39A6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10H26M29 10H26M26 10V7M26 10V13",
    stroke: "#39A6EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17C26 18.893 25.4031 20.7379 24.2942 22.2721C23.1852 23.8063 21.6208 24.9518 19.8233 25.5457C18.0258 26.1395 16.0869 26.1515 14.2822 25.5798C12.4775 25.0082 10.8991 23.882 9.77135 22.3616C8.64361 20.8411 8.02401 19.0038 8.00068 17.1109C7.97736 15.218 8.55149 13.366 9.64142 11.8182C10.7314 10.2704 12.2816 9.10569 14.0716 8.48974C15.8616 7.87379 17.8003 7.83795 19.6119 8.38732",
    stroke: "#39A6EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon1);
export default __webpack_public_path__ + "static/media/referral_icon1.597c1000dfc6babbcec921d37c7e0e7f.svg";
export { ForwardRef as ReactComponent };